import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Profiles from '../../component/Profiles';
import MypageleftArea from '../../component/MypageleftArea';
import { getMemberinfo, regPhone, patternPwCker } from "../../utils/utils";
import DaumPostcode from 'react-daum-postcode';
import ApexChart from "react-apexcharts";

import * as APIS from "../../utils/service";
import queryString from 'query-string';

// 팝업 컴포넌트
import MainPopup from '../main/MainPopup';
import NewCheckBox from '../../component/NewCheckBox';

export default function Workstatceo({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [memberinfos, setmemberinfos] = useState('');
    const [week, setweek] = useState(moment().subtract('1', 'week').day(0).format());

    const [popupShow, setpopupShow] = useState(false);
    const [popupTitle, setpopupTitle] = useState('');
    const [popupType, setpopupType] = useState(1);

    const [listType, setlistType] = useState(1);
    const [crewlists, setcrewlists] = useState([]);
    const [itembeforemonths, setitembeforemonths] = useState([]); // 
    const [customerbeforemonths, setcustomerbeforemonths] = useState([]); // 
    const [contract_list, setcontract_list] = useState([]);

    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);

    useEffect(() => {
        getlists();
    }, [week]);

    const getlists = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            weekstart: moment(week).format('YYYY-MM-DD'),
            weekend: moment(week).add(6, 'days').format('YYYY-MM-DD'),
            types: 'stat2'
        }
        //console.log("sendersendersender", sender);
        APIS.postData('/v1/compony/typedashbord', sender).then(({ data }) => {
            if (data) {
                const {
                    items, customers, blacks, componyblacks, mycomponymembers, allmembers, stayitemcklists, staycustomercklists,
                    company_news_lists, contract_lists, meetings, customeralls, crewlists, itembeforemonths, customerbeforemonths,
                    contractbeforemonths, fincustomers, realdatas, posdatas, statlists, companyUserCount, areaUserCount,
                    outsideCount
                } = data;
                setcrewlists(crewlists);
                setitembeforemonths(itembeforemonths);
                setcustomerbeforemonths(customerbeforemonths);

                let contractsetlist = [];
                contract_lists?.map((x, i) => {
                    //console.log(x);
                    let inputArrData = JSON?.parse(x?.contract);
                    let contractDate = inputArrData?.find(item => item?.keys === '날인일년')?.values + "-" + inputArrData?.find(item => item?.keys === '날인일월')?.values + "-" + inputArrData?.find(item => item?.keys === '날인일')?.values;
                    let addtwoyearsDate = moment(contractDate).add(2, 'y').format('YYYY-MM-DD');
                    let durations = moment.duration(moment().diff(addtwoyearsDate)).asDays();
                    // contractsetlist.push({ 
                    //     durations: parseInt(durations),
                    //     dates: moment(contractDate).add(2, 'y').format('M.DD'), 
                    //     stickers: inputArrData?.find(item => item?.keys === '건물용도')?.values, 
                    //     subjects: inputArrData?.find(item => item?.keys === '소재지')?.values
                    // });
                    x.durations = durations;
                    x.dates = moment(contractDate).add(2, 'y').format('M.DD');
                    x.stickers = inputArrData?.find(item => item?.keys === '건물용도')?.values;
                    x.subjects = inputArrData?.find(item => item?.keys === '소재지')?.values;
                    contractsetlist.push(x);
                })
                setcontract_list(contractsetlist);
            }
        }).catch(({ response }) => {
            console.log(response);
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    const executivesContent = () => {
        return (
            <div className='main_popup_content' style={{ marginTop: 20, padding: 0 }}>
                <div className='work_select_box'>
                    <p className={listType === 1 && 'active'} style={{ borderTopLeftRadius: 8, borderBottomLeftRadius: 8 }}
                        onClick={() => {
                            setlistType(1);
                        }}
                    >접수기준</p>
                    <p className={listType === 2 && 'active'} style={{ borderTopRightRadius: 8, borderBottomRightRadius: 8 }}
                        onClick={() => {
                            dispatch(
                                open({
                                    component: `준비중입니다.`,
                                    title: '알림',
                                    titleviewer: true,
                                    alert: false,
                                    button: "확인",
                                    onPress: () => {
                                        dispatch(close());
                                    }
                                })
                            );
                            //setlistType(2);
                        }}
                    >수수료 기준</p>
                </div>

                <div className='main_popup_list_container'>
                    <div style={{ width: 736 }}>
                        <div className='main_popup_list_index03'>
                            <div style={{ width: 100 }}>
                                <p style={{ lineHeight: '80px' }}>담당자명</p>
                            </div>
                            <div style={{ width: 256 }}>
                                <p style={{ lineHeight: '40px' }}>매물</p>
                                <div>
                                    <p style={{ lineHeight: '40px' }}>접수</p>
                                    <p style={{ lineHeight: '40px', borderRight: 0 }}>임장</p>
                                </div>
                            </div>
                            <div style={{ width: 256 }}>
                                <p style={{ lineHeight: '40px' }}>고객</p>
                                <div>
                                    <p style={{ lineHeight: '40px' }}>접수</p>
                                    <p style={{ lineHeight: '40px', borderRight: 0 }}>미팅</p>
                                </div>
                            </div>
                            <div style={{ width: 120, borderRight: 0 }}>
                                <p style={{ lineHeight: '80px' }}>계약(잔금일기준)</p>
                            </div>
                        </div>

                        <div className='work_item_list_container'>
                            {crewlists?.map((x, i) => {
                                console.log(x);
                                console.log(itembeforemonths);
                                // console.log(
                                //     itembeforemonths,
                                //     customerbeforemonths,
                                //     contract_list,
                                //     contractbeforemonths                          
                                // )

                                return (
                                    <div key={i} className='work_item_list'>
                                        <p style={{ width: 100 }}>{x?.name}</p>
                                        <p style={{ width: 129 }}>{itembeforemonths?.filter(item => item?.status * 1 === 1 && item?.u_idx * 1 === x?.idx * 1)?.length}</p>
                                        <p style={{ width: 129 }}>{itembeforemonths?.filter(item => item?.status * 1 === 2 && item?.u_idx * 1 === x?.idx * 1)?.length}</p>
                                        <p style={{ width: 129 }}>{customerbeforemonths?.filter(item => item?.status * 1 === 1 && item?.u_idx * 1 === x?.idx * 1)?.length}</p>
                                        <p style={{ width: 129 }}>{customerbeforemonths?.filter(item => item?.status * 1 === 2 && item?.u_idx * 1 === x?.idx * 1)?.length}</p>
                                        <p style={{ width: 129 }}>{contract_list?.filter(item => item?.u_idx * 1 === x?.idx * 1)?.length}</p>
                                    </div>
                                )
                            })}
                        </div>

                    </div>
                </div>
            </div>
        )
    }

    return (
        <Layout header={false} actives={''}>
            <div className='mypagearea'>
                <div >
                    <MypageleftArea pages={7} />
                </div>
                <div className='padding32'>
                    <div className='pagetitle fontsize20 bolds'>업무 통계</div>
                    <div className='pagetabs margint20'>
                        <button onClick={() => { navigate('/Workstat') }}>개인 업무 통계</button>
                        {memberinfos?.level * 1 === 3 &&
                        <button className='active' onClick={() => { navigate('/Workstatceo') }}>임직원 업무 통계</button>
                        }
                    </div>
                    <div className='mypageinputsarea'>
                        {executivesContent()}
                    </div>
                </div>
            </div>
        </Layout>
    )
}

